var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2307 0.92304C27.7894 0.92304 35.5384 8.67182 35.5384 18.2307C35.5384 27.7895 27.7894 35.5383 18.2307 35.5383C8.67193 35.5383 0.923004 27.7895 0.923004 18.2307C0.923004 8.67182 8.67193 0.92304 18.2307 0.92304Z",
    fill: "#EB5757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7166 21.9215L19.6925 6.95584C19.337 6.36627 18.6885 6 18 6C17.3115 6 16.663 6.36627 16.3074 6.95588L7.2834 21.9215C6.91597 22.5309 6.9051 23.2944 7.255 23.914C7.60498 24.5336 8.26437 24.9185 8.97594 24.9185H27.024C27.7356 24.9185 28.395 24.5336 28.745 23.9139C29.0949 23.2943 29.084 22.5308 28.7166 21.9215ZM27.4978 23.2096C27.4015 23.3802 27.2199 23.4862 27.024 23.4862H8.97594C8.78004 23.4862 8.5985 23.3802 8.50221 23.2097C8.40587 23.0391 8.40888 22.8289 8.50998 22.6612L17.5341 7.6955C17.6319 7.53321 17.8105 7.43236 18 7.43236C18.1895 7.43236 18.368 7.53321 18.4659 7.6955L27.4899 22.6612C27.5911 22.8289 27.5941 23.0391 27.4978 23.2096Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0067 11.8931C17.4618 11.8931 17.0366 12.1854 17.0366 12.7037C17.0366 14.2851 17.2226 16.5574 17.2226 18.1388C17.2227 18.5507 17.5815 18.7235 18.0067 18.7235C18.3256 18.7235 18.7775 18.5507 18.7775 18.1388C18.7775 16.5575 18.9635 14.2851 18.9635 12.7037C18.9635 12.1855 18.525 11.8931 18.0067 11.8931Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.02 19.6404C17.4353 19.6404 16.9968 20.1054 16.9968 20.6636C16.9968 21.2085 17.4353 21.6869 18.02 21.6869C18.5649 21.6869 19.03 21.2085 19.03 20.6636C19.03 20.1054 18.5648 19.6404 18.02 19.6404Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationAlertIcon);
export default __webpack_public_path__ + "static/media/notification_alert_icon.ba4dc0e181b0537b8dddd2b396badc6f.svg";
export { ForwardRef as ReactComponent };